import React from 'react';
import { getDefaultMapIcon } from "../../Helpers/map";
import { FormattedMessage as Translation } from 'react-intl';
var css = {
  "default-map": "oalp-O5YMI",
  "text-overlay": "oalp-1dq7Y"
};
var DefaultMap = function DefaultMap(_ref) {
  var staticAssetsHost = _ref.staticAssetsHost,
    siteCode = _ref.siteCode;
  return /*#__PURE__*/React.createElement("div", {
    className: css['default-map']
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 767px)",
    srcSet: "".concat(staticAssetsHost).concat(getDefaultMapIcon(siteCode, true))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(staticAssetsHost).concat(getDefaultMapIcon(siteCode)),
    alt: "Default Map for ".concat(siteCode)
  })), /*#__PURE__*/React.createElement("div", {
    className: css['text-overlay']
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "maps_load"
  })));
};
export default DefaultMap;